<script setup lang="ts">
import {onLaunch} from "@dcloudio/uni-app";
import {isAlipayBrowser, isWeixinBrowser} from "@/utils";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/store";
import {isEmpty} from "@/libs/functions";

const userStore = useUserStore();
const {openQuery, isLogin} = storeToRefs(userStore)

onLaunch(async (options) => {
  if (!isWeixinBrowser() && !isAlipayBrowser()) {
    return uni.reLaunch({url: '/pages/error/error'});
  }

  openQuery.value = options.query;
  if (!isLogin.value) {
    const code = isWeixinBrowser() ? options.query?.code : options.query?.auth_code;
    if (isEmpty(code)) {
      await userStore.getH5AuthCode();
      uni.$isResolve();
    } else {
      await userStore.getUserOpenId(code);
      uni.$isResolve();
    }
  }
});
</script>
<style>
</style>
